
(() => {
const DISC_RATE = 0.10;                        
const POLL_MS  = 100, MAX_WAIT = 5_000;          
const $  = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
const money = n => `$${n.toFixed(2)}`;

const packSize = (div) => {
  const plans = div.closest('.plans');
  if (plans?.dataset.title)
    return +plans.dataset.title.replace(/\D+/g, '') || 1;

  const sel = $("input[name='Box Size']:checked");
  return sel ? (+sel.value.replace(/\D+/g, '') || 1) : 1;
};

const render = (div) => {
  const pack   = packSize(div);
  const total  = +div.dataset.boxPrice;         

  if (!total || !pack) return;                  


  const isSub = div.closest('.subscription-option')?.dataset.value === 'subscribe';

  const perMeal     = total / pack;             
  const compareMeal = isSub                     
      ? (total / (1 - DISC_RATE)) / pack
      : null;

  const extra = div.querySelector('.extra-price') ?? (() => {
      const x = document.createElement('div');
      x.className = 'extra-price';
      div.appendChild(x);
      return x;
  })();

  extra.innerHTML =
    (isSub ? `<span style="text-decoration:line-through;">${money(compareMeal)}</span> ` : '') +
    `<span style="color:#4C6B8A;">${money(perMeal)} / per meal</span>`;
};
const init = (priceDivs) => {
  priceDivs.forEach(div => {
    if (!div.dataset.boxPrice) {                 
      const attrVal = div.getAttribute('data-price');
      div.dataset.boxPrice = attrVal
        ? (+attrVal / 100)                      
        : +(div.textContent.match(/\$([\d,.]+)/)?.[1].replace(',', '') || 0);
    }

    render(div);                                

    new MutationObserver(() => render(div))
      .observe(div, {attributes:true, attributeFilter:['data-price']});
  });

  document.addEventListener('change', e => {
    if (e.target.name === 'Box Size' || e.target.name === 'frequency-radio')
      priceDivs.forEach(render);
  }, {passive:true});
};


let waited = 0;
const timer = setInterval(() => {
  const priceDivs = $$("label[for^='frequency-'] .option-price");
  if (priceDivs.length === 2) {                  
    clearInterval(timer);
    init(priceDivs);
  } else if ((waited += POLL_MS) >= MAX_WAIT) {
    clearInterval(timer);                      
  }
}, POLL_MS);

})();
